export var ComparisonFilter;
(function (ComparisonFilter) {
    ComparisonFilter["Equal"] = "EQ";
    ComparisonFilter["GreaterThan"] = "GT";
    ComparisonFilter["GreaterOrEqual"] = "GE";
    ComparisonFilter["LowerThan"] = "LT";
    ComparisonFilter["LowerOrEqual"] = "LE";
    ComparisonFilter["Regex"] = "REGEX";
})(ComparisonFilter || (ComparisonFilter = {}));
export var NewComparisonFilter;
(function (NewComparisonFilter) {
    NewComparisonFilter["Equal"] = "EQ";
    NewComparisonFilter["NotEqual"] = "NOT_EQ";
    NewComparisonFilter["RegexMatch"] = "REGEX_MATCH";
    NewComparisonFilter["RegexNoMatch"] = "REGEX_NO_MATCH";
})(NewComparisonFilter || (NewComparisonFilter = {}));
export var MetricsOperator;
(function (MetricsOperator) {
    MetricsOperator["AND"] = "AND";
    MetricsOperator["OR"] = "OR";
    MetricsOperator["NOT"] = "NOT";
})(MetricsOperator || (MetricsOperator = {}));
export var MetricDropFilterPolicy;
(function (MetricDropFilterPolicy) {
    MetricDropFilterPolicy["DROP_BEFORE_STORING"] = "DROP_BEFORE_STORING";
    MetricDropFilterPolicy["DROP_BEFORE_PROCESSING"] = "DROP_BEFORE_PROCESSING";
})(MetricDropFilterPolicy || (MetricDropFilterPolicy = {}));
export var MetricsDropFiltersSubjects;
(function (MetricsDropFiltersSubjects) {
    MetricsDropFiltersSubjects["Table"] = "metrics-drop-filters-table";
    MetricsDropFiltersSubjects["MetricsDropFiltersPage"] = "metrics-drop-filters";
    MetricsDropFiltersSubjects["TableEmptyState"] = "metrics-drop-filters-table-empty-state";
    MetricsDropFiltersSubjects["SearchFilter"] = "search-filter";
    MetricsDropFiltersSubjects["NewFilterButton"] = "new-filter-button";
    MetricsDropFiltersSubjects["CreateFilter"] = "create-filter";
    MetricsDropFiltersSubjects["UpdateFilter"] = "update-filter";
    MetricsDropFiltersSubjects["DeleteFilter"] = "delete-filter";
    MetricsDropFiltersSubjects["ActivateFilter"] = "activate-filter";
    MetricsDropFiltersSubjects["DeactivateFilter"] = "deactivate-filter";
    MetricsDropFiltersSubjects["AccountIdSelect"] = "account-id-select";
    MetricsDropFiltersSubjects["MetricNameSelect"] = "metric-mame-select";
    MetricsDropFiltersSubjects["ModalCheckbox"] = "modal-checkbox";
    MetricsDropFiltersSubjects["Modal"] = "metrics-drop-filter-modal";
    MetricsDropFiltersSubjects["AddFilterButton"] = "add-filter-button";
    MetricsDropFiltersSubjects["MetricFieldNameSelect"] = "metric-field-name-select";
    MetricsDropFiltersSubjects["MetricFieldValueInput"] = "metric-field-value-input";
    MetricsDropFiltersSubjects["ActivationToggle"] = "activation-toggle";
    MetricsDropFiltersSubjects["BulkDeleteFilter"] = "bulk-delete-filters";
    MetricsDropFiltersSubjects["BulkCreateFilter"] = "bulk-create-filters";
    MetricsDropFiltersSubjects["DeleteAllFilter"] = "delete-all-filters";
})(MetricsDropFiltersSubjects || (MetricsDropFiltersSubjects = {}));
//# sourceMappingURL=metrics-drop-filters.enum.js.map